import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="bg-white px-4 py-5 sm:px-6" aria-labelledby="testimonials-heading" data-id="element-161" data-mp="3kqw54mwtl6h6">
      <div className="mb-3 text-center" data-id="element-162" data-mp="3fycoti6qzx8o">
        <h2 id="testimonials-heading" className="mb-0.5 font-heading text-xl uppercase leading-tight text-brand-navy sm:text-3xl" data-id="element-163" data-mp="3fxb6csnek8gx">
          Ce que disent les coachs
        </h2>
        <p className="text-[11px] font-extrabold uppercase tracking-wide text-brand-green sm:text-xs" data-id="element-164" data-mp="31zwc9am7fcim">
          Avis vérifiés de coachs et entraîneurs de padel
        </p>
      </div>
      <div className="mx-auto max-w-xl space-y-2" data-id="element-165" data-mp="2x2mn7w2q92vb">
        {testimonials.map(testimonial => <article key={testimonial.author} className="rounded-lg border border-brand-navy/10 bg-brand-cream p-3 shadow-sm" data-id="element-166" data-mp="2s42yxp0nvezs">
            <div className="mb-1 flex gap-0.5" aria-label="5 étoiles sur 5" data-id="element-167" data-mp="qbn52xkxleqg">
              {Array.from({
            length: 5
          }, (_, index) => <StarIcon key={index} className="h-3 w-3 fill-brand-green text-brand-green" aria-hidden="true" data-id="element-168" data-mp="h8az7g8j0vsa" />)}
            </div>
            <p className="mb-2 text-[11px] font-medium italic leading-snug text-brand-ink sm:text-xs" data-id="element-169" data-mp="c6llfstx640i">
              «&nbsp;{testimonial.text}&nbsp;»
            </p>
            <div className="flex items-center gap-2 border-t border-brand-navy/10 pt-2" data-id="element-170" data-mp="zx7r5dggbc7c">
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-brand-navy text-[11px] font-extrabold text-white" data-id="element-171" data-mp="14uzhi31g6q9f">
                {testimonial.author.charAt(0)}
              </span>
              <div data-id="element-172" data-mp="v3wm9hv795i2">
                <p className="text-[11px] font-extrabold text-brand-navy" data-id="element-173" data-mp="v3d3y01n0f3i">— {testimonial.author}</p>
                <p className="text-[9px] font-semibold uppercase tracking-wide text-brand-muted" data-id="element-174" data-mp="1ith6s5704atg">
                  {testimonial.role} — {testimonial.location}
                </p>
              </div>
            </div>
          </article>)}
      </div>
    </section>;
}